export default __webpack_public_path__ + "static/media/chat-hamburger.a1b76a9c.svg";